import React, { Fragment } from 'react'
import MediaQuery from 'react-responsive'

// import ganhePontos from '@loyal_images/banners/ganhe_pontos.png'

const ConexxeBanner = () => (
  <div className='bx-bannerConexxe pos-relative pb-2'>
    <div className='container px-0'>
      <div className='row mx-0'>
        <div className='col-12 px-1 px-sm-0 txt-center banner-tablet'>
          <Fragment>
            <MediaQuery maxDeviceWidth={475}>
              <img src={''} alt='Tem pontos no Sempre Presente? Transfira seus pontos para o iupp e faça suas compras.' className='w-100' />
            </MediaQuery>
            <MediaQuery minDeviceWidth={476}>
              <img src={''} alt='Tem pontos no Sempre Presente? Transfira seus pontos para o iupp e faça suas compras.' className='w-100' />
            </MediaQuery>
          </Fragment>
        </div>
      </div>
    </div>
  </div>
)

export default ConexxeBanner



// WEBPACK FOOTER //
// ./src/features/Slider/ConexxeBanner.js